import React from 'react'
import { utils, actions, selectors } from 'griddle-react'
/** Do not use recompose in other components */
import compose from 'recompose/compose'
import { createSelector } from 'reselect'
import withHandlers from 'recompose/withHandlers'

const connect = utils.connect
const pageSizeSettings = ({ pageSizes }) =>
   compose(
     connect(
       (state) => ({
         pageSize: selectors.pageSizeSelector(state),
       }),
       {
         setPageSize: actions.setPageSize
       }
     ),
     withHandlers({
       onChange: props => e => {
         props.setPageSize(+e.target.value);
       },
     }),
   )(({ pageSize, onChange }) => {
   return (
     <div>
       Items per page:
       <select onChange={onChange} defaultValue={pageSize}>
         { pageSizes.map(s => <option key={s}>{s}</option>) }
       </select>
     </div>
   )});

 const pluginConfig = {
   pageSizes: [5, 10, 20, 50],
 };

export default pageSizeSettings(pluginConfig)



// WEBPACK FOOTER //
// ../src/components/Table/components/PageSizeChooser.js